import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTranslationApp } from "../../../lib/i18next";
import Switch from "../../../components/Form/Switch";
import {
  ADS_CAMPAIGN_STATUS_ACTIVE,
  ADS_CAMPAIGN_STATUS_DELETED,
  ADS_CAMPAIGN_STATUS_DRAFT,
  ADS_CAMPAIGN_STATUS_FINISHED,
} from "../../../utils/constants";
import {
  CAMPAIGNS_STATUS_DELETED,
  CAMPAIGNS_STATUS_DRAFT,
  CAMPAIGNS_STATUS_FINISHED,
  STATUS_ACTIVE,
  STATUS_DEACTIVATED,
} from "../../../i18n/keysTranslations";

const StatusChip = ({ children, bgcolor, borderColor }) => (
  <Typography
    variant="caption"
    sx={{
      px: 1.25,
      py: 0.25,
      lineHeight: 1.2,
      borderRadius: 1,
      bgcolor,
      border: `1px solid ${borderColor}`,
      color: "#333333",
      fontWeight: 600,
      textTransform: "uppercase",
      letterSpacing: "0.5px",
      fontSize: "0.7rem",
      whiteSpace: "nowrap",
      display: "inline-block",
    }}
  >
    {children}
  </Typography>
);

const StatusSwitch = ({ status, active, onChangeStatus, readOnly = false }) => {
  const { t } = useTranslationApp();

  if (status === ADS_CAMPAIGN_STATUS_FINISHED) {
    return (
      <StatusChip
        bgcolor="rgba(158, 158, 158, 0.1)"
        borderColor="rgba(158, 158, 158, 0.3)"
      >
        {t(CAMPAIGNS_STATUS_FINISHED)}
      </StatusChip>
    );
  }

  if (status === ADS_CAMPAIGN_STATUS_DELETED) {
    return (
      <StatusChip
        bgcolor="rgba(158, 158, 158, 0.1)"
        borderColor="rgba(158, 158, 158, 0.3)"
      >
        {t(CAMPAIGNS_STATUS_DELETED)}
      </StatusChip>
    );
  }

  if (status === ADS_CAMPAIGN_STATUS_DRAFT) {
    return (
      <StatusChip
        bgcolor="rgba(255, 193, 7, 0.1)"
        borderColor="rgba(255, 193, 7, 0.3)"
      >
        {t(CAMPAIGNS_STATUS_DRAFT)}
      </StatusChip>
    );
  }

  if (readOnly) {
    const isActive = active || status === ADS_CAMPAIGN_STATUS_ACTIVE;

    return (
      <StatusChip
        bgcolor={isActive ? "rgba(19, 115, 51, 0.1)" : "rgba(197, 34, 31, 0.1)"}
        borderColor={
          isActive ? "rgba(19, 115, 51, 0.3)" : "rgba(197, 34, 31, 0.3)"
        }
      >
        {t(isActive ? STATUS_ACTIVE : STATUS_DEACTIVATED)}
      </StatusChip>
    );
  }

  return (
    <Box
      sx={{ display: "flex", pl: 0.5 }}
      onMouseDown={(event) => event.stopPropagation()}
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
      }}
    >
      <Switch
        hasLabel={false}
        isActive={active}
        size="small"
        disabled={readOnly}
        onChangeIsActive={readOnly ? undefined : onChangeStatus}
        sx={{ mt: 0.25 }}
      />
    </Box>
  );
};

export default StatusSwitch;
